import { useUrlFilters } from '@/hooks';
import { parseConversationFilters } from '../helpers';

export const useConversationFilters = () => useUrlFilters(parseConversationFilters);
